import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.roboconf = bracketIndenting({
	line: "#",
})
